import React, { useRef, useState, useEffect, useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import AvatarCrop, { AvatarChange } from '../AvatarCrop';
import { Container, EditPhoto, PhotoFavicon, DefaultPhotoFavicon, TitleFavicon } from './styles';

interface Props {
  imageSrc?: string;
  isEdit: boolean;
  name: string;
  email: string;
  saveProfileImage?: (val: AvatarChange) => void;
}

const FaviconPhotoInfo = ({ imageSrc, isEdit, name, email, saveProfileImage }: Props) => {
  const { t } = useStoreTranslation();

  const [file, setFile] = useState<File>();
  const [src, setSrc] = useState<string>();
  const [isShowCrop, setIsShowCrop] = useState<boolean>(false);
  const [imgCrop, setImgCrop] = useState<string>();

  const inputRef = useRef<HTMLInputElement>(null);

  const handleUpload = () => {
    inputRef.current?.click();
  };

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file as File);
      reader.onload = () => {
        setSrc(reader.result as string);
        setIsShowCrop(true);
      };
    }
  }, [file]);

  const handleChangePhoto = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files?.item(0) || undefined;
    setFile(newFile);
  }, []);

  const handleCloseCrop = useCallback(() => {
    setIsShowCrop(false);
  }, []);

  const handleConfirmCrop = useCallback(() => {
    setIsShowCrop(false);
  }, []);

  const handleCropImage = useCallback((val: AvatarChange) => {
    setImgCrop(val.image);
    if (saveProfileImage !== undefined) {
      saveProfileImage(val);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AvatarCrop
        show={isShowCrop}
        cropImage={handleCropImage}
        onConfirm={handleConfirmCrop}
        onClose={handleCloseCrop}
        src={src}
        width={16}
        height={16}
      />
      <Container>
        <TitleFavicon>{t('companyConfigurationForm.favicon')}</TitleFavicon>

        {isEdit && (
          <EditPhoto type="button" onClick={handleUpload}>
            <label>{t('companyConfigurationForm.editFavicon')}</label>
            <input type="file" accept="image/*" ref={inputRef} onChange={handleChangePhoto} />
          </EditPhoto>
        )}

        {imageSrc && imageSrc !== '' ? (
          <PhotoFavicon>
            <img src={imgCrop ?? imageSrc} alt="" />
          </PhotoFavicon>
        ) : (
          <DefaultPhotoFavicon>
            <img src="/corporate/images/favicon-netviajes.ico" alt="" />
          </DefaultPhotoFavicon>
        )}
        
      </Container>
    </>
  );
};

export default FaviconPhotoInfo;
